import type * as api from '@gitbook/api-client';
import { SPACE_DEFAULT_TITLE } from '@gitbook/app-database';
import { HeadTitle } from '@gitbook/util-react-head';

/**
 * HTML `<head>` title for the space.
 */
export function SpaceHeadTitle(props: {
    title: string;
    space: api.Space;
    changeRequest: api.ChangeRequest | null;
}) {
    const { title, space, changeRequest } = props;
    const spaceTitle = space.title || SPACE_DEFAULT_TITLE;

    return (
        <HeadTitle
            title={(() => {
                if (changeRequest) {
                    return `#${changeRequest.number} - ${spaceTitle} - ${title}`;
                }
                return `${title} - ${spaceTitle}`;
            })()}
        />
    );
}
